import { AfterContentInit, Component, ContentChildren, Input, OnInit, QueryList, TemplateRef } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-owl-carousel',
  templateUrl: './owl-carousel.component.html',
  styleUrls: ['./owl-carousel.component.scss']
})
export class OwlCarouselComponent implements OnInit, AfterContentInit {

  @Input() customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 1 },
      400: { items: 2 },
      680: { items: 3 },
      890: { items: 4 }
    },
    nav: true
  };

  @ContentChildren('slideTemplate', { read: TemplateRef }) slides!: QueryList<TemplateRef<any>>;
  slideTemplates: TemplateRef<any>[] = [];


  /**
   * Default constructor for OwlCarouselComponent.
   */
  constructor() { }


  /**
   * Angular lifecycle hook that is called after data-bound properties are initialized.
   */
  ngOnInit() {
  }

  /**
   * Angular lifecycle hook that is called after content (ng-content) has been initialized.
   * Converts the QueryList of slide templates to an array for use in the component.
   */
  ngAfterContentInit() {
    this.slideTemplates = this.slides.toArray();
  }
}
